import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import i18n from '../../i18n/i18n';

const BASE_URL = process.env.REACT_APP_BASE_URL || "https://hefnawy.brmjatech.co.uk/api";

// دالة مساعدة للحصول على التوكن
const getAuthToken = () => {
  const adminData = sessionStorage.getItem('adminkhadamat');
  if (adminData) {
    try {
      const parsed = JSON.parse(adminData);
      // البحث عن التوكن في أماكن مختلفة
      if (parsed.data?.token?.access_token) {
        const token = String(parsed.data.token.access_token);
        return token;
      }
      if (parsed.data?.access_token) {
        return parsed.data.access_token;
      }
      if (parsed.data?.token) {
        return parsed.data.token;
      }
      if (parsed.token) {
        return parsed.token;
      }
      if (parsed.result?.token) {
        return parsed.result.token;
      }
      if (parsed.user?.token) {
        return parsed.user.token;
      }
      return null;
    } catch (error) {
      return null;
    }
  }
  return null;
};

// Helper function to get current language
const getCurrentLanguage = () => {
  return i18n.language || 'ar';
};

// Fetch all users
export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (page = 1, thunkAPI) => {
    try {
      
      const token = getAuthToken();
      const currentLang = getCurrentLanguage();


      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const url = `${BASE_URL}/admin/admins?page=${page}`;
     
      
      const response = await axios.get(url, {
        headers: { 
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "lang": currentLang,
        },
      });
      
      return response.data;
    } catch (error) {
 
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "فشل في جلب المستخدمين"
      );
    }
  }
);

// Fetch single user
export const fetchUser = createAsyncThunk(
  "users/fetchUser",
  async (id, thunkAPI) => {
    try {
    
      
      const token = getAuthToken();
      const currentLang = getCurrentLanguage();
      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const url = `${BASE_URL}/admin/admins/${id}`;
      
      const response = await axios.get(url, {
        headers: { 
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "lang": currentLang,
        },
      });
      
      return response.data;
    } catch (error) {
   
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "فشل في جلب بيانات المستخدم"
      );
    }
  }
);

// Create new user
export const createUser = createAsyncThunk(
  "users/createUser",
  async (userData, thunkAPI) => {
    try {

      
      const token = getAuthToken();
      const currentLang = getCurrentLanguage();
      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const url = `${BASE_URL}/admins/add_new`;
      
      // إرسال البيانات المطلوبة فقط
      const requestData = {
        email: userData.email,
        password: userData.password
      };
      
      
      const response = await axios.post(url, requestData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "lang": currentLang,
        },
      });
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "فشل في إنشاء المشرف"
      );
    }
  }
);

// Update user
export const updateUser = createAsyncThunk(
  "users/updateUser",
  async ({ id, userData }, thunkAPI) => {
    try {
  
      const token = getAuthToken();
      const currentLang = getCurrentLanguage();
      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const url = `${BASE_URL}/admins/update_one/${id}`;
      
      // إرسال البيانات المطلوبة فقط
      const requestData = {
        email: userData.email
      };
      
      // إضافة كلمة المرور إذا تم إدخالها
      if (userData.password && userData.password.trim() !== '') {
        requestData.password = userData.password;
      }
      
      
      const response = await axios.post(url, requestData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "lang": currentLang,
        },
      });
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "فشل في تحديث المشرف"
      );
    }
  }
);

// Change user status
export const changeUserStatus = createAsyncThunk(
  "users/changeUserStatus",
  async (id, thunkAPI) => {
    try {
   
      const token = getAuthToken();
      const currentLang = getCurrentLanguage();
      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const url = `${BASE_URL}/admins/change_status/${id}`;
      
      const response = await axios.post(url, {}, {
        headers: { 
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "lang": currentLang,
        },
      });
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "فشل في تغيير حالة المشرف"
      );
    }
  }
);

// Delete user
export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id, thunkAPI) => {
    try {

      
      const token = getAuthToken();
      const currentLang = getCurrentLanguage();
      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      const url = `${BASE_URL}/admin/admins/${id}`;
      
      const response = await axios.delete(url, {
        headers: { 
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "lang": currentLang,
        },
      });
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "فشل في حذف المستخدم"
      );
    }
  }
);

const userSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    currentUser: null,
    pagination: null,
    isLoading: false,
    error: null,
    success: null,
    createSuccess: false,
    updateSuccess: false,
    deleteSuccess: false,
    selectedUserForEdit: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
      state.createSuccess = false;
      state.updateSuccess = false;
      state.deleteSuccess = false;
    },
    clearCurrentUser: (state) => {
      state.currentUser = null;
    },
    setSelectedUserForEdit: (state, action) => {
      state.selectedUserForEdit = action.payload;
    },
    clearSelectedUserForEdit: (state) => {
      state.selectedUserForEdit = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Users
      .addCase(fetchUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload.result || action.payload.data || [];
        state.pagination = action.payload.pagination || {};
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "فشل في جلب المستخدمين";
      })
      
      // Fetch Single User
      .addCase(fetchUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentUser = action.payload.result || action.payload.data || action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "فشل في جلب بيانات المستخدم";
      })
      
      // Create User
      .addCase(createUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.createSuccess = true;
        state.success = action.payload.message;
        // Add new user to the list
        if (action.payload.result || action.payload.data) {
          const newUser = action.payload.result || action.payload.data;
          state.users.unshift(newUser);
        }
      })
      .addCase(createUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "فشل في إنشاء المستخدم";
      })
      
      // Update User
      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateSuccess = true;
        state.success = action.payload.message;
        // Update user in the list
        if (action.payload.result || action.payload.data) {
          const updatedUser = action.payload.result || action.payload.data;
          const index = state.users.findIndex(user => user.id === updatedUser.id);
          if (index !== -1) {
            state.users[index] = updatedUser;
          }
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "فشل في تحديث المستخدم";
      })
      
      // Change User Status
      .addCase(changeUserStatus.fulfilled, (state, action) => {
        // تحديث حالة المستخدم في القائمة
        const userIndex = state.users.findIndex(user => user.id === action.payload.id);
        if (userIndex !== -1) {
          state.users[userIndex].status = action.payload.status;
        }
      })
      .addCase(changeUserStatus.rejected, (state, action) => {
        state.error = action.payload?.message || action.payload || "فشل في تغيير حالة المستخدم";
      })
      
      // Delete User
      .addCase(deleteUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.deleteSuccess = true;
        state.success = action.payload.message;
        // Remove user from the list
        state.users = state.users.filter(user => user.id !== action.meta.arg);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "فشل في حذف المستخدم";
      });
  },
});

export const { clearState, clearCurrentUser, setSelectedUserForEdit, clearSelectedUserForEdit } = userSlice.actions;
export default userSlice.reducer;
